import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import environment from '../constants/environment';

import theme from '../constants/theme';

import {
  capitalise,
  formatLocation,
  getFirstName,
  isCSR,
  trackEvent,
  typeToReadableSEOType,
  typeToSEOType,
} from '../helpers';
import { auth } from '../database';

import ContactActions from '../actions/contact';
import InstagramActions from '../actions/instagram';
import VendorActions from '../actions/vendor';
import UserActions from '../actions/user';

import { Container, ContainerInner } from './Container';
import Breadcrumbs from './Breadcrumbs';
import Header from './Header';
import Footer from './Footer';
import MessageBox from './MessageBox';
import VendorProfile from './VendorProfile';

class VendorProfileWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    profile: {},
  };

  static requestInitialData(routeData) {
    const { slug, type } = routeData.params;
    return VendorActions.fetchVendor(slug);
  }

  componentDidMount() {
    const { vendor, dispatch } = this.props;

    if (!!vendor?.id) {
      const { id } = vendor;
      const vendorId = id;
      if (!!vendor?.detail?.instagram) {
        dispatch(InstagramActions.fetchIg(id));
      }
      auth.onAuthStateChanged(user => {
        if (user) {
          const userId = user.uid;
          trackEvent({ event: 'page-view', userId, vendorId });
          dispatch(UserActions.identifyUser(user));
        } else {
          trackEvent({ event: 'page-view', vendorId });
        }
      });

      dispatch(ContactActions.getFormContactDetails());
      dispatch(ContactActions.getMessageHistory());
    }
  }

  render() {
    const { contact, faqs, packages, vendor, user } = this.props;
    const { userId = null } = user;

    const structuredDataImages = vendor.gallery
      ? vendor.gallery.map(o => o.original).slice(5, 10)
      : {}; // Pick 5 images to put in structured data
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      image: structuredDataImages,
      '@id': vendor.url,
      name: vendor.business,
      address: {
        '@type': 'PostalAddress',
        addressLocality: vendor.area_level_2,
        addressRegion: vendor.area_level_1,
        addressCountry: vendor.country,
      },
      url: vendor.url,
      telephone: vendor.phone,
    };

    if (!vendor?.id || vendor.is_fetching) {
      return <div>Loading...</div>;
    }

    return (
      <ThemeProvider theme={theme}>
        <Container>
          <Header />
          <ContainerInner>
            <Breadcrumbs
              items={[
                {
                  label: `Wedding ${typeToReadableSEOType(
                    vendor.type
                  )} in ${formatLocation(vendor.country, vendor.area_level_1)}`,
                  href: `/${typeToSEOType(vendor.type)}/${vendor.area_level_1}`,
                },
                {
                  label: vendor.area_level_2
                    ? formatLocation(vendor.country, vendor.area_level_2)
                    : 'All',
                  href: `/${typeToSEOType(vendor.type)}/${vendor.area_level_1}/${
                    vendor.area_level_2
                  }`,
                },
                {
                  label: `${getFirstName(vendor.contact)}`,
                  href: vendor.url,
                },
              ]}
            />

            <VendorProfile vendor={vendor} userId={userId} />

            {/* contact_details is null so we hide this until we have received the data, even if its empty */}
            {isCSR && contact.contact_details && <MessageBox userId={userId} />}

            <Footer />
            <Helmet>
              <meta property="og:title" content={vendor.business}></meta>
              <meta
                name="description"
                content={`Wedding ${vendor.type} in ${capitalise(
                  vendor.area_level_2
                )} ${capitalise(vendor.area_level_1)}. ${vendor.description}`}
              ></meta>
              <meta
                property="og:description"
                content={`${capitalise(vendor.type)} in ${capitalise(
                  vendor.area_level_1
                )}`}
              />
              <meta
                property="og:image"
                content={
                  _.has(vendor, 'contact_image.original')
                    ? vendor.contact_image.original
                    : `${environment.baseDomain}/static/og-image.jpg`
                }
              />
              <meta property="og:url" content={vendor.url} />
              <title>{vendor.business} | Say I do</title>
              <link
                rel="canonical"
                href={`https://sayi.do/${typeToSEOType(
                  vendor.type
                )}/${vendor.area_level_1 || 'all'}/${vendor.area_level_2 || 'all'}/${
                  vendor.slug
                }`}
              />
              <script type="application/ld+json">
                {JSON.stringify(structuredData)}
              </script>
            </Helmet>
          </ContainerInner>
        </Container>
      </ThemeProvider>
    );
  }
}

// VendorProfileWrapper.requestInitialData = (routeData, dispatch) => {
//   console.log(`requestInitialData for VendorProfileWrapper`);
//   // const dispatch = useDispatch();
//   const { slug, type } = routeData.params;
//   console.log('xxx', slug, 'yyy', dispatch);
//   // dispatch(VendorActions.fetchVendor(slug));
// };

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(VendorActions, dispatch),
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    contact: state.contact,
    faqs: state.faqs,
    packages: state.packages,
    vendor: state.vendor,
    user: state.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorProfileWrapper);
